import { render, staticRenderFns } from "./Freelancers.vue?vue&type=template&id=3a9c0b64&scoped=true"
import script from "./Freelancers.vue?vue&type=script&lang=js"
export * from "./Freelancers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9c0b64",
  null
  
)

export default component.exports